import { render, staticRenderFns } from "./SystemPanel.vue?vue&type=template&id=b14dcb0a&scoped=true"
import script from "./SystemPanel.vue?vue&type=script&lang=js"
export * from "./SystemPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b14dcb0a",
  null
  
)

export default component.exports